<template>
	<div>
		<div class="content-i">
			<div class="content-box" style="padding-bottom: 0px;">
				<div class="element-wrapper" style="padding-bottom: 0px;">
					<h6 class="element-header">{{ t('titleManageEndUsers','titleManageEndUsers') }}</h6>				
					<div class="element-box">
						<div class="element-info">
							<div class="row">
								<div class="col-12 col-sm-6 col-md-8">
									<div class="element-info-with-icon">
										<div class="element-info-icon">
											<span class="os-icon os-icon-search2"></span>
										</div>
										<div class="element-info-text">
											<h5 class="element-inner-header">{{ t('headerManageEndUsersSearch','headerManageEndUsersSearch') }}</h5>
											<div class="element-inner-desc">{{ t('manageEndUsersFormDesc', 'manageEndUsersFormDesc') }}</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-3 col-md-4">
									<i id="endUsersSearchToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
								</div>
							</div>
						</div>
						<b-collapse id="search" visible>
							<form v-on:submit.prevent="requestEndUsersList">
								<div class="row">
									<div class="col-6">
										<div class="row">
											<div class="col-6">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserCustomerNameLabel', 'endUserCustomerNameLabel') }}</span>
													</div>
													<div class="col-6">
														<input class="form-control" v-model="endUsersListRequest.customer_name" type="text">
													</div>
												</div>
											</div>
											<div class="col-6">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserUserNameLabel', 'endUserUserNameLabel') }}</span>
													</div>
													<div class="col-6">
														<input class="form-control" v-model="endUsersListRequest.user_name" type="text">
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserReferenceLabel', 'endUserReferenceLabel') }}</span>
													</div>
													<div class="col-6">
														<input class="form-control" v-model="endUsersListRequest.customer_reference" type="text">
													</div>
												</div>
											</div>
											<div class="col-6">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserUserEmailLabel', 'endUserUserEmailLabel') }}</span>
													</div>
													<div class="col-6">
														<input class="form-control" v-model="endUsersListRequest.user_email" type="text">
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-6">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserLockedUsersLabel', 'endUserLockedUsersLabel') }}</span>
													</div>
													<div class="col-6">
														<b-form-checkbox value="1" unchecked-value="0" v-model="endUsersListRequest.user_locked"></b-form-checkbox>
													</div>
												</div>
											</div>	
											<div class="col-6" v-if="protectedUserEnabled == '1'">
												<div class="row block-input-row">
													<div class="col-6">
														<span>{{ t('endUserProtectedLabel', 'endUserProtectedLabel') }}</span>
													</div>
													<div class="col-6">
														<b-form-checkbox value="1" unchecked-value="0" v-model="endUsersListRequest.user_protected"></b-form-checkbox>
													</div>
												</div>
											</div>									
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-right">
										<button v-if="!isBusy" class="btn btn-primary" type="submit" >{{ t('searchCustomerUsersBtn','searchCustomerUsersBtn') }}</button>
										<b-button v-else variant="primary" disabled>
											<b-spinner small type="grow"></b-spinner>
											{{ t('searchCustomerUsersBtn','searchCustomerUsersBtn') }}
										</b-button>
									</div>
								</div>
							</form>
						</b-collapse>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-left: 30px; padding-right: 30px">
			<transition name="fade">
				<ResponseInfo v-if="getResponseInfo.responseName == 'manageEndUsers'" class="mt-2"/>				
			</transition>			
		</div>
    <!-- NS-9846, check to fix on refresh issue -->
		<div class="content-i" v-if="dataRequested">
    	<div class="content-box" style="padding-top: 10px;">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table">
								<div class="col-sm-12 col-md-6 table-records-info px-0" v-if="getCustomerEndUsers.data">
									<p>{{ totalRows }} {{ t('endUsersListEntriesFound','endUsersListEntriesFound') }}</p>
								</div>
								<div class="col-sm-12 col-md-4">
									<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
									</b-pagination>
								</div>
								<div class="col-sm-12 col-md-2">
									<b-input-group class="form-group col-lg-12">
										<b-input-group-prepend>
											<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
										</b-input-group-prepend>
										<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
									</b-input-group>
								</div>
              </div>
              <!-- NS-9846 Added protected user legend PW -->
              <div v-if="protectedUserEnabled == '1'" class="col-12 text-left px-0">
                <fieldset class="d-flex mt-0 b-0">
                  <ul class="no-list-style px-0">
                    <li class="d-inline">
                      <span class="d-inline-block colour-sample orange-label align-middle"> </span>
                      <span class="px-1 align-middle">{{ t('protectedUserText', 'protectedUserText') }}</span>
                    </li>
                  </ul>
                </fieldset>
              </div>
              <div class="table-responsive">
								<b-table id="logs-table" striped hover bordered class="mt-3" :busy.sync="isBusy" :items="getCustomerEndUsers.data" :fields="fields" :total-rows="totalRows" :per-page="0" :currentPage="currentPage" :show-empty="rowEmpty" :tbody-tr-class="rowClass">
									<template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="data.item">
                    <vcl-table :rows="parseInt(perPage)" :columns="5"></vcl-table>
                  </template>
									<template v-slot:head(endUserId)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(endUserUserName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(endUserEmail)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
									<template v-slot:head(endUserCustomerName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(endUserCustomerReference)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(endUserOperations)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(endUserAccountStatusToggle)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>									
									<!-- tbody -->
									<template v-slot:cell(endUserId)="data">
                    <span >{{ data.item.id }}</span>
                  </template>
                  <template v-slot:cell(endUserUserName)="data">
                    <span >{{ data.item.username }}</span>
                  </template>
                  <template v-slot:cell(endUserEmail)="data">
                    <span >{{ data.item.email }}</span>
                  </template>
									<template v-slot:cell(endUserCustomerName)="data">
                    <span >{{ data.item.customer_name }}</span>
                  </template>
                  <template v-slot:cell(endUserCustomerReference)="data">
										<router-link :to="{ path: `/customers_accounts/manage_customers?customerReference=` + `${data.item.customer_ref}`}">{{ data.item.customer_ref }}</router-link>
                  </template>
                  <template v-slot:cell(endUserOperations)="data">
										<b-link v-if="data.item.email_protected == 0 || getUserLevel > 2.00" class="px-1" href="#" @click="openEditModal(t('editEndUserDetailsModalTitle', 'editEndUserDetailsModalTitle'), data.item.id, data.item.level, data.item.name, data.item.email, data.item.password, data.item.email_protected, data.item.head_user, data.item.hash_logon, $event.target)">
											Edit
										</b-link>
										<b-link class="px-1" v-if="getUserLevel >= 2.00 && data.item.level < 3.00" href="#" @click="openEmailModal(t('sendEmailEndUserModalTitle', 'sendEmailEndUserModalTitle'), data.item.id, data.item.email, data.item.password, $event.target)">
											Email
										</b-link>
										<b-link v-if="(data.item.email_protected == 0 || getUserLevel > 2.00) && (getUserDetails.id != data.item.id)" class="px-1" href="#" @click="openDeleteModal(t('deleteEndUserModalTitle', 'deleteEndUserModalTitle'), data.item.id, data.item.email, $event.target)">
											Delete
										</b-link>
										<router-link :to="{ name: 'customer_user_delivery_options', params: { id: data.item.id, customer: data.item.customer_id } }">
											Delivery Options
										</router-link>										
                  </template>
									<template v-slot:cell(endUserAccountStatusToggle)="data">
										<toggle-button @change="editAccountStatus($event, data.item)" :value="Boolean(!data.item.account_disabled)" :font-size="15" :height="30" :width="95" :color="{checked: '#008000', unchecked: '#B22222'}" :sync="true" :labels="{checked: 'Active', unchecked: 'Inactive'}"/>
									</template>
								</b-table>
							</div>
              <div class="controls-below-table pt-4">
								<div class="col-sm-12 col-md-6 table-records-info px-0" v-if="getCustomerEndUsers.data">
									<p>{{ totalRows }} {{ t('endUsersListEntriesFound','endUsersListEntriesFound') }}</p>
								</div>
								<div class="col-sm-12 col-md-4" v-if="getCustomerEndUsers.data">
									<b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
									</b-pagination>
								</div>
								<div class="col-sm-12 col-md-2">
									<b-input-group class="form-group col-lg-12">
										<b-input-group-prepend>
											<label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
										</b-input-group-prepend>
										<b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
									</b-input-group>
								</div>
              </div>							
						</div>			
					</div>
				</div>
			</div>
		</div>
		<!-- EDIT MODAL -->
		<b-modal class="modal-lg" :id="editModal.id" :title="editModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetEditModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ editModal.title }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('realNameLabelText', 'realNameLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="real_name" v-model="editModal.name"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('emailLabelText', 'emailLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" v-model="editModal.email"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('passwordLabelText', 'passwordLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input :disabled="getUserDetails.id != editModal.userId && getUserLevel == editModal.level" id="user_password" v-model="editModal.password" :type="'password'"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('headUserLabelText', 'headUserLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select :disabled="getUserLevel < 2.00" v-model="editModal.headUser" :options="headUserAndProtectedOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group v-if="protectedUserEnabled == '1'" class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('protectedUserLabelText', 'protectedUserLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select v-model="editModal.protectedUser" :options="headUserAndProtectedOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('userLevelLabelText', 'userLevelLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select :disabled="getUserDetails.id != editModal.userId && getUserLevel == editModal.level" v-model="editModal.userLevel" :options="userLevelOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('hashAuthenticationLabelText', 'hashAuthenticationLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-select v-model="editModal.hashLogon" :options="userHashLogonOptions" value-field="value" text-field="text"></b-form-select>
						</b-input-group>
						<div class="col-lg-12 py-1">
							<span class="pretext-span tips-font-size">if hash logon is enabled and this box is ticked the emails sent to the user will be allowed to use the variable "[HASH]". By default "[HASH]" return an empty string.</span>
						</div>																																																		
					</b-form-group>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" @click="updateEndUser()">Update</button>
			</template>
			<ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'endUserError'"></ValidationErrors>			
		</b-modal>
		<!-- EMAIL MODAL -->
		<b-modal class="modal-lg" size="lg" :id="emailModal.id" :title="emailModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetEmailModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ emailModal.title }}</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
			</template>
			<template slot="default">
				<div class="row modal-body-log">
					<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('sendToLabelText', 'sendToLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="real_name" v-model="emailModal.sendTo"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('subjectLabelText', 'subjectLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="email_address" v-model="emailModal.subject"></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('fromLabelText', 'fromLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-input id="user_password" v-model="emailModal.from" ></b-form-input>
						</b-input-group>
						<b-input-group class="py-2">
							<b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
								<b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('messageLabelText', 'messageLabelText') }}</span></b-input-group-text>
							</b-input-group-prepend>
							<b-form-textarea id="email-to" v-model="emailModal.message" class="form-control" rows="5" max-rows="5" required>
							</b-form-textarea>
						</b-input-group>
            <b-input-group class="py-0">
              <div class="col-5"></div>
              <div class="col-7">
                <div class="col-12 px-0 mb-2">
                  {{ t('sendUserLoginDetailsModalDesc', 'sendUserLoginDetailsModalDesc') }}
                </div>
                <ul style="list-style-type: none;" class="px-0">
                  <li class="px-0 py-1">[USERNAME] - {{ t('sendUserDetailsUsernamePlaceholder', 'sendUserDetailsUsernamePlaceholder') }}</li>
                  <li class="px-0 py-1">[PASSWORD] - {{ t('sendUserDetailsPasswordPlaceholder', 'sendUserDetailsPasswordPlaceholder') }}</li>
                  <li class="px-0 py-1">[CLIENT_NAME] - {{ t('sendUserDetailsClientNamePlaceholder', 'sendUserDetailsClientNamePlaceholder') }}</li>
                  <li class="px-0 py-1">[BASE_HREF] - {{ t('sendUserDetailsBaseHrefPlaceholder', 'sendUserDetailsBaseHrefPlaceholder') }}</li>
                </ul>
              </div>
            </b-input-group>																																		
					</b-form-group>
				</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" :disabled="!emailModal.sendTo" @click="sendEmail()">Send Email</button>
			</template>
			<ValidationErrors class="p-1" v-if="getValidationErrors.validationName == 'endUserError'"></ValidationErrors>			
		</b-modal>		
		<!-- DELETE MODAL -->
		<b-modal class="modal-lg" :id="deleteModal.id" :title="deleteModal.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetDeleteModal()">
			<template slot="modal-header" slot-scope="{ close }">
				<h5 class="modal-title text-light">{{ deleteModal.title }} ?</h5>
				<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
			</template>
			<template slot="default">
					<div class="row modal-body-log">                   
						<div v-if="!(deleteModal.userId === undefined)" class="col-lg-12 py-2"><span class="">{{ t('deleteEndUserModalQuestion','deleteEndUserModalQuestion') }} </span> <span class="font-weight-bold">"{{ deleteModal.email }}"? </span></div>                     
					</div>
			</template>
			<template slot="modal-footer" slot-scope="{ close }">
				<button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
				<button type="button" class="btn btn-primary" @click="deleteEndUser()">Yes</button>
			</template>
		</b-modal>		
		<div v-if="editModal.title" class="modal-backdrop show"></div>
		<div v-if="deleteModal.title" class="modal-backdrop show"></div>
		<div v-if="emailModal.title" class="modal-backdrop show"></div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'
import { VclTable } from 'vue-content-loading'

export default {
	name: 'ManageEndUsersView',
	components: {
		ResponseInfo,
		ValidationErrors,
		VclTable
	},
  data() {
		return {
      isBusy: false,			
			pageOptions: [10, 20, 50, 100],
			currentPage: 1,
			perPage: 20,
			totalRows: 0,
			rowEmpty: true,
			protectedUser: null,
      activation: '',
      dataRequested: false,	
			endUsersListRequest: {	
				customer_reference: this.$route.query.customer_reference ? this.$route.query.customer_reference : '',
				customer_name: this.$route.query.customer_name ? this.$route.query.customer_name : '',
				user_email: this.$route.query.user_email ? this.$route.query.user_email : '',
				user_name: this.$route.query.user_name ? this.$route.query.user_name : '',
				user_protected: this.$route.query.user_protected ? this.$route.query.user_protected : 0,
        user_locked: this.$route.query.user_locked ? this.$route.query.user_locked : 0
			},
			fields: [
				{key: 'endUserId', label: 'endUsersTableUserIdLabel', thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'endUserUserName', label: 'endUsersTableUserNameLabel', sortable: true, thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'endUserEmail', label: 'endUsersTableUserEmailLabel', thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'endUserCustomerName', label: 'endUsersTableCustNameLabel', thClass: 'showhand brand-color', tdClas: 'text-center'},
				{key: 'endUserCustomerReference', label: 'endUsersTableCustRefLabel', thClass: 'showhand brand-color', tdClass: 'text-center'},
				{key: 'endUserOperations', label: 'endUsersTableOperationsLabel', thClass: 'showhand brand-color'},
				{key: 'endUserAccountStatusToggle', label: 'endUsersTableAccountStatusToggle', thClass: 'brand-color', tdClass: 'text-center'}
			],
			editModal: {
				id: 'edit-modal-customerEndUser',
				title: '',
				level: '',
				userId: null,
				name: '',
				email: '',
				password: '',
				userLevel: 0.00,
				protectedUser: 0,
				headUser: 0,
				hasLogon: 0
			},
			emailModal: {
				id: 'email-modal-endUser',
				userId: null,
				title: '',
				sendTo: '',
				subject: '',
				from: '',
				message: '',
				password: ''
			},
			deleteModal: {
				id: 'delete-modal-endUser',
				title: '',
				userId: null,
				email: ''
			},
			headUserAndProtectedOptions: [
				{ value: 0, text: 'no'},
				{ value: 1, text: 'yes'}
			],
			userLevelOptions: [
				{ value: 0.00, text: 'End User'}
			],
			userHashLogonOptions: [
				{ value: 0, text: 'disabled'},
				{ value: 1, text: 'enabled'}
			]	
		}
	},
	created() {
		this.$store.dispatch('endUsersAdminLogonsStore/getProtectedUser').then(() => {
			this.protectedUser = this.$store.getters['endUsersAdminLogonsStore/getProtectedUser']
		}, this)
	},
	methods: {
		rowClass(item) {
			if(item) {
				if(item.email_protected) {
					if(item.email_protected == 1 && this.protectedUser == 1 ) {
						return "red-row"
					}
				}
			}
		},		
		requestEndUsersList() {
			this.isBusy = true
			Object.keys(this.endUsersListRequest).forEach((key) => ((this.endUsersListRequest[key] == '') || (this.endUsersListRequest[key] == null)) && (this.endUsersListRequest[key] = undefined))
			this.$router.push({ query: { ...this.$route.query, ...this.endUsersListRequest, page: this.currentPage, per_page: this.perPage }})
			
			this.$store.dispatch('endUsersAdminLogonsStore/getEndUsersList', {
				page: this.currentPage,
				per_page: this.perPage,
				customerReference: this.endUsersListRequest.customer_reference,
				customerName: this.endUsersListRequest.customer_name,
				userEmail: this.endUsersListRequest.user_email,
				userName: this.endUsersListRequest.user_name,
				userProtected: this.endUsersListRequest.user_protected,
        userLocked: this.endUsersListRequest.user_locked
			}).then(() => {
				this.isBusy = false
        this.totalRows = this.getCustomerEndUsers.total
        this.dataRequested = true
        
        // NS-9846 added check for no results, PW
        if(this.totalRows == 0) {
          this.rowEmpty = true
        } else {
          this.rowEmpty = false
        }
			})
		},
		openEditModal(title, userId, level, name, email, password, protectedUser, headUser, hashLogon, button) {
			this.editModal.title = title
			this.editModal.userId = userId
			this.editModal.level = level			
			this.editModal.name = name
			this.editModal.email = email
			this.editModal.protectedUser = protectedUser
			this.editModal.headUser = headUser
			this.editModal.hashLogon = hashLogon
			this.$root.$emit('bv::show::modal', this.editModal.id, button)
		},
		openDeleteModal(title, userId, email, button) {
			this.deleteModal.title = title
			this.deleteModal.userId = userId
			this.deleteModal.email = email
			this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
		},
		openEmailModal(title, userId, email, password, button) {
			this.emailModal.title = title
			this.emailModal.userId = userId
			this.$store.dispatch('endUsersAdminLogonsStore/getEndUserEmailDetails', {
				id: this.emailModal.userId 
			}).then(() => {
				this.emailModal.message = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].message
				this.emailModal.sendTo = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].email
				this.emailModal.subject = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].subject
				this.emailModal.from = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].from
				this.emailModal.password = this.$store.getters['endUsersAdminLogonsStore/getEmailForm'].password
				
				this.$root.$emit('bv::show::modal', this.emailModal.id, button)
			})
		},
		resetEditModal() {
			this.editModal.title = ''
			this.editModal.userId = null
			this.editModal.level = ''			
			this.editModal.name = ''
			this.editModal.email = ''
			this.editModal.password = ''
			this.editModal.protectedUser = 0
			this.editModal.headUser = 0
			this.editModal.hashLogon = 0
			this.$store.commit('alertClearErrors', null)
		},
		resetEmailModal() {
				this.emailModal.userId = null
				this.emailModal.title = ''
				this.emailModal.sendTo = ''
				this.emailModal.subject = ''
				this.emailModal.from = ''
				this.emailModal.message = ''
				this.$store.commit('alertClearErrors', null)
		},
		resetDeleteModal() {
			this.deleteModal.title = ''
			this.deleteModal.userId = null
			this.deleteModal.email = ''
		},
		deleteEndUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/deleteEndUser', {
				userId: this.deleteModal.userId,
				currentUser: this.$store.getters.getUserDetails.id
			}).then(() => {
				this.requestEndUsersList()
				this.$root.$emit('bv::hide::modal', this.deleteModal.id)
			})			
		},
		updateEndUser() {
			this.$store.dispatch('endUsersAdminLogonsStore/updateEndUser', {
				userId: this.editModal.userId,
				name: this.editModal.name,
				email: this.editModal.email,
				level: this.editModal.level,
				password: this.editModal.password,
				protectedUser: this.editModal.protectedUser,
				headUser: this.editModal.headUser,
				hashLogon: this.editModal.hashLogon,
				currentUser: this.$store.getters.getUserDetails.id
			}).then(() => {
				this.requestEndUsersList()
				if(this.getValidationErrors.userEmail == undefined && this.getValidationErrors.updatePassword == undefined){
					this.$root.$emit('bv::hide::modal', this.editModal.id)
				}
			})
		},
		editAccountStatus(event, data) {
			data.account_disabled = !data.account_disabled
			let account_status = 0
			if(data.account_disabled) {
				account_status = 1
			} else {
				account_status = 0
			}
			this.$store.dispatch('endUsersAdminLogonsStore/updateAccountStatus', {
				userId: data.id,
				account_disabled: account_status,
				currentUser: this.$store.getters.getUserDetails.id
			})
		},
		sendEmail() {
			this.$store.dispatch('endUsersAdminLogonsStore/sendEmailToUser', {
				userId: this.emailModal.userId,
				sendTo: this.emailModal.sendTo,
				from: this.emailModal.from,
				subject: this.emailModal.subject,
				password: this.emailModal.password,
				message: this.emailModal.message,
				component: 'endUsers'
			}).then(() => {
				if(this.getValidationErrors.userEmail == undefined){
					this.$root.$emit('bv::hide::modal', this.emailModal.id)
				}
			})			
		}
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel', 'getUserDetails', 'getValidationErrors']),
		...mapGetters('endUsersAdminLogonsStore', ['getCustomerEndUsers', 'getProtectedUser', 'getEmailForm']),
    protectedUserEnabled() {
      return this.$store.getters['endUsersAdminLogonsStore/getProtectedUser']
    }
	},
  watch: {
    'currentPage'() {
      this.requestEndUsersList()
    },
    'perPage'() {
      this.requestEndUsersList()
    }
  }	
}
</script>

<style scoped>
  .block-input-row {
    align-items: center;
    text-align: right;
    margin-top: 5px;
  }
  .text-netsend-blue {
    color: #047bf8;
  }
  #endUsersSearchToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
    cursor: pointer;
  }
  #endUsersSearchToggle.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
	table >>> tbody, table >>> thead {
    text-align: center;
  }
	table >>> tr.red-row{
		background-color: #f5be98 !important;
	}
  .colour-sample{
    width: 15px;
    height: 15px;
    border: 1px solid rgba(83, 101, 140, 0.33);
  }
  .orange-label {
    background-color: #f5be98;
  }
</style>